import { render } from "./safety.section.html?vue&type=template&id=6fe478d8&scoped=true&lang=html&external"
import script from "./safety.section.vue?vue&type=script&lang=js"
export * from "./safety.section.vue?vue&type=script&lang=js"

import "./_safety.section.mobile.scss?vue&type=style&index=0&id=6fe478d8&lang=scss&scoped=true&external"
import "./_safety.section.desktop.scss?vue&type=style&index=1&id=6fe478d8&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fe478d8"]])

export default __exports__